import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { environment } from 'src/environments/environment';
import { MemberService } from '../services/MemberService';
import { AlertService } from '../services/AlertService';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../services/UserService';
import { AppBreadcrumbService } from '../app.breadcrumb.service';
import { LazyLoadEvent } from 'primeng/api';
import { DataView } from 'primeng/dataview';
import { LookupValuesService } from '../common/lookup-values.service';
import { AccountService } from '../services/AccountService';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  private geoCoder;
  kmlurl: string[] = [];
  members: any[] = [];
  officeCols: any[] = [];
  @ViewChild('search')
  public searchElementRef: ElementRef;
  activeTabIndex: number = 0;
  canAddMember: boolean = false;
  canAddUser: boolean = false; 
  canSearchInactive: boolean = false; 

  searchText: string = '';
  searchLocation: string = '';
  searchBrokerResultList: any[] = [];
  searchMemberResultList: any[] = [];
  searchBrokerDisplayList: any[] = [];
  searchMemberDisplayList: any[] = [];
  searchDialogMemberMessage: string = '';
  searchDialogUserMessage: string = '';
  IncludeInactive: boolean = false;
  filterType: any[] = [{ type: 'All', value: 'All' }, { type: 'Favorites', value: 'Favorite' }];
  filterBy: string = 'All';
  queryParams: any = { TextSearch: '', LocationSearch: '' };

  totalMembers: number;
  totalBrokers: number;
  rowsPerPage: number = 5;
  isPaginator: boolean = true;
  @ViewChild('dvmember', { static: false }) dataViewMember: DataView;
    @ViewChild('dvbroker', { static: false }) dataViewBroker: DataView;
    selectedOfficeMemberSearch: number = 0;   
    AdvanceSearchDialogVisible: boolean = false;
    AdvanceSearchText: string = '';
    AdvanceSearchResultList: any[] = [];
    AdvanceSearchDialogMessage: string = '';
    
    options: any;
    countryOptions: any[] = [];
    stateOptions: any[] = [];
    regionOptions: any[] = [];

    advanceSearchName: string = '';
    advanceSearchCountryId: number = 0;
    advanceSearchRegionId: number = 0;
    advanceSearchStateId: number = 0;
    advanceSearchCity: string = '';
    advanceSearchLocation: string = '';
    isadvanceSearch: boolean = false; 

   

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private memberservice: MemberService,
    private alertService: AlertService,
    private router: Router,
    private userservice: UserService,
    private breadcrumbService: AppBreadcrumbService,
    private activatedRoute: ActivatedRoute,
    private lookupvaluesservice: LookupValuesService,   
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.searchLocation = place.formatted_address
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          this.saveQueryParms();
          this.GetMembersByTerritories();
        });
      });
    });
    this.canAddMember = this.accountService.CanAddNews();
    this.canAddUser = this.accountService.CanAddUser();
    this.canSearchInactive = this.accountService.CanSearchInactive();
    this.AdvanceSearchDialogVisible = true;
    this.officeCols = [
      { field: 'Id', header: 'Id', display: 'none' },
      { field: 'Icon', header: 'Icon', display: 'none' },
      { field: 'Name', header: 'Member Name', display: 'none' },
      { field: 'IsHQ', header: 'Is HQ', display: 'none' },
      { field: 'OfficePhone', header: 'Phone', display: 'table-cell' },
      { field: 'OfficeEmail', header: 'Email', display: 'table-cell' },
      { field: 'ExclusivityArea', header: 'Exclusivity Area', display: 'table-cell' }
    ];
    this.breadcrumbService.setItems([this.breadcrumbService.search]);
      this.ReloadSearchFields();
      this.options = this.activatedRoute.snapshot.data['options'];
      this.parseOptions();
      
  }

    parseOptions() {
        this.countryOptions = new Array();
        for (let o of this.options[0]) {
            let l = o.Name;
            this.countryOptions.push({ label: l, value: o.Id });
        };
        this.regionOptions = new Array();
        for (let o of this.options[1]) {
            let l = o.Name;
            this.regionOptions.push({ label: l, value: o.Id });
        };
    }
  lazyLoadMembers(event: LazyLoadEvent) {
    if(this.isadvanceSearch)
    {
       this.searchMembersAdvanceLazy(event.first, event.rows);
    }
    else
    {
      this.searchMembers(event.first, event.rows);
    }
  }

  searchMembers(first, numberOfRow) {
    if (this.searchText != '') {
      this.memberservice.SearchMembersLazy(first, numberOfRow, this.searchText, this.IncludeInactive).subscribe(res => {
        if (res.length != 0) {
          this.searchMemberResultList = res.Members;
          this.totalMembers = res.TotalMembers;
            this.FilterLists();           
        }
        else {
          this.searchDialogMemberMessage = 'No Offices Found. Please email help@naiglobal.com';
        }
      });
    } else {
      this.searchDialogMemberMessage = 'Search keywords are required';
    }
  }

  searchMembersAdvanceLazy(first, numberOfRow) {

    this.searchDialogMemberMessage = '';
    let  advanceSearchParams: any = { First:0, 
      NumberOfRow: 0, 
      currentUserId: 0, 
      includeInactive: false, 
      SearchString: '', 
      CountryId: 0, 
      StateId: 0, 
      RegionId:0, 
      City:''};
      advanceSearchParams.First = first;
      advanceSearchParams.NumberOfRow = numberOfRow,       
      advanceSearchParams.includeInactive = this.IncludeInactive,
      advanceSearchParams.SearchString = this.advanceSearchName,
      advanceSearchParams.CountryId = this.advanceSearchCountryId,
      advanceSearchParams.StateId = this.advanceSearchStateId,
      advanceSearchParams.RegionId = this.advanceSearchRegionId,
      advanceSearchParams.City = this.advanceSearchCity
    
      this.memberservice.SearchMembersAdvanceLazy(advanceSearchParams).subscribe(res => {
        if (res.Members!= null && res.Members.length != 0) {
          this.searchMemberResultList = res.Members;
          this.totalMembers = res.TotalMembers;
            this.FilterLists();  
        }
        else {
          this.searchDialogMemberMessage = 'No Offices Found. Please email help@naiglobal.com';
        }
      });
    }     
  

  lazyLoadBrokers(event: LazyLoadEvent) {
    if(this.isadvanceSearch)
    {
      this.searchBrokersAdvanceLazy(event.first, event.rows);
    }
    else{
      this.searchBrokers(event.first, event.rows);
    }
  }

  searchBrokers(first, numberOfRow) {
    if (this.searchText != '') {
      this.userservice.SearchUsersLazy(first, numberOfRow, this.searchText, this.IncludeInactive).subscribe(res => {
        if (res.length != 0) {
          this.searchBrokerResultList = res.Users;
          this.totalBrokers = res.TotalUsers;
          this.FilterLists();
        }
        else {
          this.searchDialogUserMessage = 'No Brokers Found. Please email help@naiglobal.com';
        }
      });
    } else {
      this.searchDialogUserMessage = 'Search keywords are required';
    }
  }

  searchBrokersAdvanceLazy(first, numberOfRow) {

    let  advanceSearchParams: any = { First:0, 
      NumberOfRow: 0, 
      currentUserId: 0, 
      includeInactive: false, 
      SearchString: '', 
      CountryId: 0, 
      StateId: 0, 
      RegionId:0, 
      City:''};
      advanceSearchParams.First = first;
      advanceSearchParams.First = first;
      advanceSearchParams.NumberOfRow = numberOfRow,       
      advanceSearchParams.includeInactive = this.IncludeInactive,
      advanceSearchParams.SearchString = this.advanceSearchName,
      advanceSearchParams.CountryId = this.advanceSearchCountryId,
      advanceSearchParams.StateId = this.advanceSearchStateId,
      advanceSearchParams.RegionId = this.advanceSearchRegionId,
      advanceSearchParams.City = this.advanceSearchCity
    
      this.userservice.SearchUsersAdvanceLazy(advanceSearchParams).subscribe(res => {
        if (res.Users != null && res.Users.length != 0) {
          this.searchBrokerResultList = res.Users;
          this.totalBrokers = res.TotalUsers;
          this.FilterLists();
        }
        else {
          this.searchDialogUserMessage = 'No Brokers Found. Please email help@naiglobal.com';;
        }
      });
    }     
  


  private ReloadSearchFields() {
    this.queryParams = this.breadcrumbService.getQueryParams(this.breadcrumbService.search.url);
    if (this.queryParams != null && this.queryParams.params != null) {
      this.searchText = this.queryParams.params.TextSearch ? this.queryParams.params.TextSearch : '';
      this.searchLocation = this.queryParams.params.LocationSearch ? this.queryParams.params.LocationSearch : '';
      this.latitude = this.queryParams.params.Latitude ? this.queryParams.params.Latitude : '';
      this.longitude = this.queryParams.params.Longitude ? this.queryParams.params.Longitude : '';
      this.advanceSearchName = this.queryParams.params.advanceSearchName ? this.queryParams.params.advanceSearchName : '';
      this.advanceSearchCountryId = this.queryParams.params.advanceSearchCountryId ? this.queryParams.params.advanceSearchCountryId : 0;
      this.advanceSearchRegionId = this.queryParams.params.advanceSearchRegionId ? this.queryParams.params.advanceSearchRegionId : 0;
      this.advanceSearchStateId = this.queryParams.params.advanceSearchStateId ? this.queryParams.params.advanceSearchStateId : 0;
      this.advanceSearchCity = this.queryParams.params.advanceSearchCity ? this.queryParams.params.advanceSearchCity : '';
      this.isadvanceSearch = this.queryParams.params.isadvanceSearch ? this.queryParams.params.isadvanceSearch : false;  
     
      
    }

    if (this.isadvanceSearch == false && this.searchText != '') {
      this.Search();
      this.activeTabIndex = 0;
    }

    if ( this.isadvanceSearch == false && this.searchLocation != '') {
      this.activeTabIndex = 1;
      this.GetMembersByTerritories();
    }
    if(this.isadvanceSearch == true)
    {
      this.advanceSearchProfessional();
      this.AdvanceSearchDialogVisible = false;
    }
  }


  private saveQueryParms() {
  this.queryParams = { TextSearch: this.searchText, LocationSearch: this.searchLocation, Latitude: this.latitude, Longitude: this.longitude, 
    advanceSearchName: this.advanceSearchName,
    advanceSearchCountryId: this.advanceSearchCountryId,
    advanceSearchRegionId: this.advanceSearchRegionId,
    advanceSearchStateId: this.advanceSearchStateId,
    advanceSearchCity: this.advanceSearchCity,
    advanceSearchLocation: this.advanceSearchLocation,
    isadvanceSearch: this.isadvanceSearch };
  this.breadcrumbService.saveQueryParams(this.breadcrumbService.search.url, this.queryParams);
}

  private GetMembersByTerritories() {
  if (this.latitude != null && this.longitude != null) {
    this.memberservice.GetMemberByTerritoryCoordinates(this.latitude, this.longitude).subscribe(
      res => {
        this.members = res;
        this.kmlurl = new Array();
        for (let o of res) {
          let l = o.Id;
          this.kmlurl.push(environment.kmlBase.concat('/TerritoryKML/', l, '.kml?t=', Date.now().toString()));
        }
      },
      error => {
        this.alertService.SetMessage('error', 'There is an error while searching');
      }
    )
  }
}

  private setCurrentLocation() {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition((position) => {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.zoom = 8;
      this.getAddress(this.latitude, this.longitude);
    });

  }
}

getAddress(latitude, longitude) {
  this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
    if (status === 'OK') {
      if (results[0]) {
        this.zoom = 8;
        this.address = results[0].formatted_address;
      } else {
        window.alert('No results found');
      }
    } else {
      window.alert('Geocoder failed due to: ' + status);
    }

  });
}
IsPaginatorOffLocationVisible(): boolean {
  return this.members.length > 20 ? true : false;
}
IsOfficeLocationDataTableVisible(): boolean {
  return this.members.length > 0 ? true : false;
}
FormatColumnData(value: any, col: any): string {
  var result = value;
  return result;
}
navToMemberProfile(Id) {
  this.router.navigate(['/member/' + Id]);
}

Search() {
  this.isadvanceSearch = false;
  this.searchDialogMemberMessage = '';
  this.searchDialogUserMessage = ''
  this.searchBrokerDisplayList = [];
  this.searchMemberDisplayList = [];
  this.searchBrokerResultList = [];
  this.searchMemberResultList = [];
  this.searchMembers(0, this.rowsPerPage);
  if (this.dataViewMember != null) {
    this.dataViewMember.first = 0
  }
  this.searchBrokers(0, this.rowsPerPage);
  if (this.dataViewBroker != null) {
    this.dataViewBroker.first = 0
  }
  this.saveQueryParms();
}

getBrokerName(broker) {
  let result = "Select a professional";
  if (broker.FName != undefined || broker.LName != undefined) {
    result = broker.FName + ' ' + broker.LName;
  }
  return result;
}
navToBrokerProfile(broker) {
  if (broker != null)
    this.router.navigate(['/user/' + broker.Id]);
}
UpdateMemberFavorite(member: any) {
  this.memberservice.UpdateMemberFavorite(member).subscribe(
    result => {
      if (result) {
        var newFavStatus = !member.IsFavorite;
        member.IsFavorite = newFavStatus;
      }
    },
    error => {
      this.alertService.SetMessage('error', 'There is an error while Updating Favorite');
    }
  );
}
UpdateBrokerFavorite(broker: any) {
  this.userservice.UpdateUserFavorite(broker).subscribe(
    result => {
      if (result) {
        var newFavStatus = !broker.IsFavorite;
        broker.IsFavorite = newFavStatus;
      }
    },
    error => {
      this.alertService.SetMessage('error', 'There is an error while Updating Favorite');
    }
  );
}

FilterLists(){
  if (this.filterBy == 'Favorite') {
    this.searchBrokerDisplayList = this.searchBrokerResultList.filter(
      b => b.IsFavorite == true);
    this.searchMemberDisplayList = this.searchMemberResultList.filter(
      b => b.IsFavorite == true);
  }
  else {
    this.searchBrokerDisplayList = this.searchBrokerResultList;
      this.searchMemberDisplayList = this.searchMemberResultList;

      if ((this.searchMemberDisplayList == null || this.searchMemberDisplayList.length == 0) &&
          (this.searchBrokerDisplayList != null && this.searchBrokerDisplayList.length > 0)) {
          this.selectedOfficeMemberSearch = 1;
      }

      if ((this.searchMemberDisplayList != null && this.searchMemberDisplayList.length > 0) &&
          (this.searchBrokerDisplayList == null || this.searchBrokerDisplayList.length == 0)) {
          this.selectedOfficeMemberSearch = 0;
      }
    }
    }

    onClickAdvanceSearch() {
        this.AdvanceSearchDialogVisible = true;
        this.resetSearchLocation();
    }

    onChangeCountry() {
        if (this.advanceSearchCountryId != 0) {
            this.lookupvaluesservice.GetRegionOptionsByCountry(this.advanceSearchCountryId).subscribe(res => {
                this.regionOptions = new Array();
                for (let o of res) {
                    let l = o.Name;
                    this.regionOptions.push({ label: l, value: o.Id });
                }
            });
            this.lookupvaluesservice.GetStateOptions(this.advanceSearchCountryId).subscribe(res => {
                this.stateOptions = new Array();
                for (let o of res) {
                    let l = o.Name;
                    this.stateOptions.push({ label: l, value: o.Id });
                }
            });
        }
        
    }

    onChangeRegion() {
        if (this.advanceSearchRegionId != 0) {
            this.lookupvaluesservice.GetStateOptionsByRegion(this.advanceSearchRegionId).subscribe(res => {
                this.stateOptions = new Array();
                for (let o of res) {
                    let l = o.Name;
                    this.stateOptions.push({ label: l, value: o.Id });
                }
            });
        }
    }

    advanceSearchProfessional() {
      this.activeTabIndex = 0;
      this.AdvanceSearchDialogVisible = false;
      this.isadvanceSearch = true;
      this.searchDialogMemberMessage = '';
      this.searchDialogUserMessage = ''
      this.searchBrokerDisplayList = [];
      this.searchMemberDisplayList = [];
      this.searchBrokerResultList = [];
      this.searchMemberResultList = [];
      this.searchMembersAdvanceLazy(0, this.rowsPerPage);
      if (this.dataViewMember != null) {
        this.dataViewMember.first = 0
      }
      this.searchBrokersAdvanceLazy(0, this.rowsPerPage);
      if (this.dataViewBroker != null) {
        this.dataViewBroker.first = 0
      }
      this.saveQueryParms();
    }

    advanceSearchByLocation() {

    }

    resetSearchLocation() {
        this.advanceSearchName = '';
        this.advanceSearchCountryId = 0;
        this.advanceSearchRegionId = 0;
        this.advanceSearchStateId = 0;
        this.advanceSearchCity = '';
        this.advanceSearchLocation = '';
        this.lookupvaluesservice.GetRegionOptions().subscribe(res => {
            this.regionOptions = new Array();
            for (let o of res) {
                let l = o.Name;
                this.regionOptions.push({ label: l, value: o.Id });
            }
        });
        this.isadvanceSearch = true;
    }
}
